



















import Component, { mixins } from "vue-class-component";
import BlockBase from "@/components/BlockBase.vue";
import BlockBaseForm from "@/components/BlockBaseForm.vue";
import PageTitle from "@/components/PageTitle.vue";
import { FormValues } from "@/types";
import { Prop } from "vue-property-decorator";
import paymentPackageMixin from "../mixins/paymentPackageMixin";
import PaymentPackageEditForm from "./PaymentPackageEditForm.vue";
import { InputPaymentPackageCreate, PaymentPackageType } from "@teacherskaya/api-provider/dist/api/PaymentPackageProvider";
import { Currency } from "@teacherskaya/api-provider/dist/api/CurrencyProvider";

@Component({
  name: "BlockPaymentPackageAdd",
  components: { PaymentPackageEditForm, PageTitle, BlockBaseForm, BlockBase },
})
export default class BlockPaymentPackageAdd extends mixins(paymentPackageMixin) {
  @Prop({ type: String, required: true })
  public readonly type!: PaymentPackageType;

  @Prop({ type: Boolean, default: false })
  public readonly hideCosts!: boolean;

  @Prop({ type: String, required: true })
  public readonly title!: string;

  @Prop({ type: Array, required: true })
  public readonly currencyList!: Currency[];

  public save(values: FormValues, vm?: any) {
    const data: InputPaymentPackageCreate = {
      name: values.name || "",
      costs: values.costs || [],
      amount: values.amount && Number(values.amount) > 0 ? Number(values.amount) : Number(values.cost),
      type: this.type,
    };
    this.$emit("save", { data, vm });
  }

  public cancel() {
    this.$emit("cancel");
  }
}
